import { AnswerResult, Question } from '@/models/Question';
import { Questionnaire } from '@/models/Questionnaire';

export enum QuestionnaireTypes {
    LIST_QUESTIONNAIRES_REQUEST = '@questionnaire/LIST_QUESTIONNAIRES_REQUEST',
    LIST_QUESTIONNAIRES_SUCCESS = '@questionnaire/LIST_QUESTIONNAIRES_SUCCESS',
    LIST_QUESTIONNAIRES_FAILURE = '@questionnaire/LIST_QUESTIONNAIRES_FAILURE',
    GENERATE_QUESTIONNAIRE_REQUEST = '@questionnaire/GENERATE_QUESTIONNAIRE_REQUEST',
    GENERATE_QUESTIONNAIRE_FAILURE = '@questionnaire/GENERATE_QUESTIONNAIRE_FAILURE',
    GET_QUESTIONNAIRE_REQUEST = '@questionnaire/GET_QUESTIONNAIRE_REQUEST',
    GET_QUESTIONNAIRE_SUCCESS = '@questionnaire/GET_QUESTIONNAIRE_SUCCESS',
    GET_QUESTIONNAIRE_FAILURE = '@questionnaire/GET_QUESTIONNAIRE_FAILURE',
    GET_QUESTION_REQUEST = '@questionnaire/GET_QUESTION_REQUEST',
    GET_QUESTION_SUCCESS = '@questionnaire/GET_QUESTION_SUCCESS',
    GET_QUESTION_FAILURE = '@questionnaire/GET_QUESTION_FAILURE',
    GET_QUESTION_CLEAR = '@questionnaire/GET_QUESTION_CLEAR',
    UPDATE_ANSWER_REQUEST = '@questionnaire/UPDATE_ANSWER_REQUEST',
    UPDATE_ANSWER_SUCCESS = '@questionnaire/UPDATE_ANSWER_SUCCESS',
    UPDATE_ANSWER_FAILURE = '@questionnaire/UPDATE_ANSWER_FAILURE',
    FINISH_QUESTIONNAIRE_REQUEST = '@questionnaire/FINISH_QUESTIONNAIRE_REQUEST',
    FINISH_QUESTIONNAIRE_SUCCESS = '@questionnaire/FINISH_QUESTIONNAIRE_SUCCESS',
    FINISH_QUESTIONNAIRE_FAILURE = '@questionnaire/FINISH_QUESTIONNAIRE_FAILURE',
    GET_QUESTIONNAIRE_RESULT_REQUEST = '@questionnaire/GET_QUESTIONNAIRE_RESULT_REQUEST',
    GET_QUESTIONNAIRE_RESULT_SUCCESS = '@questionnaire/GET_QUESTIONNAIRE_RESULT_SUCCESS',
    GET_QUESTIONNAIRE_RESULT_FAILURE = '@questionnaire/GET_QUESTIONNAIRE_RESULT_FAILURE',
    CLEAR_QUESTIONNAIRE_STORE = '@questionnaire/CLEAR_QUESTIONNAIRE_STORE',
    START_QUESTIONNAIRE_REQUEST = '@questionnaire/START_QUESTIONNAIRE_REQUEST',
    START_QUESTIONNAIRE_SUCCESS = '@questionnaire/START_QUESTIONNAIRE_SUCCESS',
    START_QUESTIONNAIRE_FAILURE = '@questionnaire/START_QUESTIONNAIRE_FAILURE',
}

export interface QuestionnaireState {
    question: Question;
    questionnnaire: Questionnaire;
    questionnnaires: Questionnaire[];
    responseSummary: AnswerResult[];
    loading: boolean;
    hasError: boolean;
    success: boolean;
    answered: boolean;
    successOnQuestionnaireList: boolean;
    successOnFinishQuestionnaire: boolean;
    successOnStartQuestionnaire: boolean;
}
